import styled from 'styled-components';

export const SubscriptionContainer = styled.div`
    max-width: 325px;
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
